
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55 35.11c-.13-.38-3.17-9.42-3.56-10.35a6.65 6.65 0 00-6-3.83h-8.22V14a1 1 0 00-1-1H6.4a1 1 0 00-1 1v21.88H5a1 1 0 00-1 1v6.33a1 1 0 001 1h4.6a4.62 4.62 0 004.5 3.62 4.61 4.61 0 004.5-3.62h21.25a4.62 4.62 0 004.5 3.62 4.62 4.62 0 004.5-3.62h2.29c1.5 0 3.89-1.71 3.89-3.74v-5a.89.89 0 00-.03-.36zM14.12 45.83a2.62 2.62 0 01-2.62-2.62 2.62 2.62 0 012.62-2.61 2.61 2.61 0 012.62 2.61 2.621 2.621 0 01-2.63 2.64l.01-.02zm21.09-3.62H18.62a4.61 4.61 0 00-9 0H6v-4.33h29.19l.02 4.33zm0-20.28v14H7.4V15.05h27.85l-.04 6.88zm15 5.38c.56 1.6 1.35 3.94 2 5.89l-6.19-1.62v-4.27h4.19zm-5.86 18.52a2.62 2.62 0 01-2.62-2.62 2.62 2.62 0 015.24 0 2.62 2.62 0 01-2.61 2.64l-.01-.02zm8.68-5.36c0 .77-1.37 1.74-1.89 1.74h-2.29a4.62 4.62 0 00-4.5-3.61 4.619 4.619 0 00-4.5 3.61h-2.66v-5.06c.01-.09.01-.18 0-.27v-14h8.22a4.639 4.639 0 014 2.38H45a1 1 0 00-1 1v6a1 1 0 00.75 1l8.21 2.15v.13l.07 4.93z"}})])
          )
        }
      }
    